import {
  PopUpFocusProps,
  PopUpHintsProps,
  PopUpKeepGoingProps,
  PopUpPauseProps,
  PopUpSummaryProps,
  PopUpTimeIsUpProps,
  PopUpTypes,
  PopUpWordsListProps,
} from '@/types/game';

import PopUpKeepGoing from './PopUpKeepGoing/PopUpKeepGoing';
import PopUpFocus from './PopUpFocus/PopUpFocus';
import PopUpTimeIsUp from './PopUpTimeIsUp/PopUpTimeIsUp';
import PopUpPause from './PopUpPause/PopUpPause';
import PopUpSummary from './PopUpSummary/PopUpSummary';
import PopUpHints from './PopUpHints/PopUpHints';
import PopUpWordsList from './PopUpWordsList/PopUpWordsList';
import PopUpOpenWrittingAIReview from './PopUpOpenWrittingAIReview/PopUpOpenWrittingAIReview';
import PopUpCanDoStatement from './PopUpCanDoStatement/PopUpCanDoStatement';
import PopUpFinishUnit from './PopUpFinishUnit/PopUpFinishUnit';

const popUps = [
  {
    type: PopUpTypes.KeepGoing,
    component: PopUpKeepGoing,
  },
  {
    type: PopUpTypes.Focus,
    component: PopUpFocus,
  },
  {
    type: PopUpTypes.TimeIsUp,
    component: PopUpTimeIsUp,
  },
  {
    type: PopUpTypes.Pause,
    component: PopUpPause,
  },
  {
    type: PopUpTypes.Summary,
    component: PopUpSummary,
  },
  {
    type: PopUpTypes.Hints,
    component: PopUpHints,
  },
  {
    type: PopUpTypes.WordsList,
    component: PopUpWordsList,
  },
  {
    type: PopUpTypes.OpenWrittingAIReview,
    component: PopUpOpenWrittingAIReview,
  },
  {
    type: PopUpTypes.CanDoStatement,
    component: PopUpCanDoStatement,
  },
  {
    type: PopUpTypes.FinishUnit,
    component: PopUpFinishUnit,
  },
];

interface QuizPopUpProps {
  type: PopUpTypes | null;
  className: string;
}

const QuizPopUp = (
  props: QuizPopUpProps &
    (
      | PopUpKeepGoingProps
      | PopUpFocusProps
      | PopUpTimeIsUpProps
      | PopUpPauseProps
      | PopUpSummaryProps
      | PopUpHintsProps
      | PopUpWordsListProps
    )
) => {
  const popUpObj = popUps.find(popUp => popUp.type === props?.type);

  const ComponentToRender = popUpObj && popUpObj.component;

  return ComponentToRender ? <ComponentToRender {...props} /> : null;
};

export default QuizPopUp;
